import React from 'react'

const EventForm = () => {
    return (
        <div>
            Form
        </div>
    )
}

export default EventForm
